export const formatColWidth = (width: number, columnDivisions: number) => `${(width / columnDivisions) * 100}%`;

export const formatOverlayWidth = (width: number, columnDivisions: number, fixedWidth: number) =>
  `${(width / columnDivisions) * fixedWidth}px`;
